import { Component } from '@angular/core';
import { AdminActionsDirective } from '@app/main/admin/directives/admin-actions.directive';
import { AdminService } from '../../../admin.service';
import { SnackService } from '@shared/services/snack.service';
import { HyperlinkService } from '@shared/services/hyperlink.service';
import { IHyperlink } from '@shared/interfaces';
import { DialogService } from '@shared/services';
import { ModuleService } from '@shared/services/module.service';

@Component({
    selector: 'app-admin-toolbar-hyperlink',
    templateUrl: './admin-toolbar-hyperlink.component.html',
    styleUrls: ['./admin-toolbar-hyperlink.component.scss'],
    standalone: false
})
export class AdminToolbarHyperlinkComponent extends AdminActionsDirective {
    searchValue: string;

    constructor(
        private hyperlinkService: HyperlinkService,
        private snack: SnackService,
        adminService: AdminService,
        dialogService: DialogService,
        moduleService: ModuleService
    ) {
        super(adminService, dialogService, moduleService);
    }

    async deleteHyperlink(): Promise<void> {
        try {
            const result = await this.deleteDialog();
            if (!result) {
                return;
            }
        } catch (e) {
            throw new Error('Failed to confirm hyperlink deletion.', { cause: e });
        }

        try {
            await this.hyperlinkService.deleteItem(this.item);
            this.snack.openSnackBarSuccess(`Hyperlink item ${this.item.title} deleted successfully.`);
            this.goToHyperlinks();
        } catch (e) {
            this.snack.openSnackBarError(e.error.message);
        }
    }

    get item(): IHyperlink {
        return this.selectedItem;
    }
}
